export default __webpack_public_path__ + "static/mediamarkt-logo-4caef2f941b0bcd5578300c39847ab81.svg";